export const SIGN_IN_GOAL = 'WIKI_PROMO_SIGN-IN_CLICK';
export const SHOW_GOAL = 'WIKI_PROMO_SHOW';

export const PRIVACY_URL = 'https://yandex.ru/legal/confidential/';
export const TERMS_URL = 'https://yandex.ru/legal/cloud_termsofuse/';
